declare global {
  interface Window {
    LoginWrapperConfig: {
      mountPointId: string;
      succeeded: (token: string, ssoRedirectUrl: string)  => void;
      failed: ()  => void;
    };
  }
}

const LoginWrapperConfigDefaults = {
  mountPointId: 'login_app',
  succeeded: (token: string, ssoRedirectUrl: string)  => {
    location.reload();
  },
  failed: () => {}
};

const config = window.LoginWrapperConfig || LoginWrapperConfigDefaults;
config.mountPointId = config.mountPointId || LoginWrapperConfigDefaults.mountPointId;
config.succeeded = config.succeeded || LoginWrapperConfigDefaults.succeeded;
config.failed = config.failed || LoginWrapperConfigDefaults.failed;

export default config;
